import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { passwordOk, resetPassword } from "../lib/authApi";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!token || !passwordOk(password)) return;
    setBusy(true);
    const { res, data } = await resetPassword(token, password);
    setBusy(false);
    if (res.ok) {
      setOk(true);
      setMsg(data.message || "Password updated. You can sign in now.");
    } else {
      setMsg(data.message || "Reset failed or link expired.");
    }
  }

  if (!token) {
    return (
      <div className="auth-bg flex min-h-full items-center justify-center px-4 py-10">
        <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
          <p className="text-status-error">Missing reset token.</p>
          <Link to="/login" className="mt-4 inline-block text-sm text-accent hover:underline">
            Sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-bg flex min-h-full items-center justify-center px-4 py-10">
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
        <h1 className="text-lg font-semibold text-text-primary">Set new password</h1>
        {ok ? (
          <p className="mt-3 text-sm text-status-ok">{msg}</p>
        ) : (
          <form className="mt-4" onSubmit={onSubmit}>
            <label className="mb-1 block text-xs text-text-secondary" htmlFor="new-pass">
              New password
            </label>
            <input
              id="new-pass"
              type="password"
              className="auth-input mb-4"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className="auth-primary" disabled={busy || !passwordOk(password)}>
              Update password
            </button>
            {msg && !ok && <p className="mt-3 text-sm text-status-error">{msg}</p>}
          </form>
        )}
        <Link to="/login" className="mt-6 inline-block text-sm text-accent hover:underline">
          Sign in
        </Link>
      </div>
    </div>
  );
}
